import PropTypes from "prop-types";
import Answer from "../Answer";

const QuestionAnswer = ({ questionAnswer }) => {
  return (
    <div className="question-answer">
      <p>{questionAnswer.question}</p>
      {questionAnswer.answers.map((answer, index) => {
        return <Answer key={index} label={answer} questionType={questionAnswer.type} answerId={index} />;
      })}
    </div>
  );
};

QuestionAnswer.propTypes = {
  questionAnswer: PropTypes.object,
};

export default QuestionAnswer;
